import axios from "axios";

/* ======================================================
   GET FOLLOWING MEDIA POSTS
   GET /api/media-post

   Returns media posts from:
   - users the current user follows
   - the current user's own posts

   Each media post includes its comments.
====================================================== */
export async function fetchMediaPosts({
  limit = 100,
  cursor = null,
} = {}) {

  try {

    const res =
      await axios.get(

        "/api/media-post",

        {
          params: {
            limit,
            ...(cursor
              ? {
                  cursor,
                }
              : {}),
          },

          withCredentials: true,
        }

      );

    return res.data;

  } catch (err) {

    throw err;

  }

}

/* ======================================================
   GET GLOBAL MEDIA POSTS
   GET /api/media-post/global

   Returns global media posts.

   Each media post includes its comments.
====================================================== */
export async function fetchGlobalMediaPosts({
  limit = 100,
  cursor = null,
} = {}) {

  try {

    const res =
      await axios.get(

        "/api/media-post/global",

        {
          params: {
            limit,
            ...(cursor
              ? {
                  cursor,
                }
              : {}),
          },

          withCredentials: true,
        }

      );

    return res.data;

  } catch (err) {

    throw err;

  }

}

/* ======================================================
   GET MY MEDIA POSTS
   GET /api/media-post/mine

   Returns the logged-in user's own media posts.

   Supports cursor-based pagination.
====================================================== */
export async function fetchMyMediaPosts({
  limit = 50,
  cursor = null,
} = {}) {

  try {

    const res =
      await axios.get(

        "/api/media-post/mine",

        {
          params: {
            limit,
            ...(cursor
              ? {
                  cursor,
                }
              : {}),
          },

          withCredentials: true,
        }

      );

    return res.data;

  } catch (err) {

    throw err;

  }

}
/* ======================================================
   GET AUTHOR MEDIA POSTS
   GET /api/media-post/user/:chatId

   Returns media posts belonging to one specific author.

   Supports cursor-based pagination.
====================================================== */
export async function fetchUserMediaPosts({
  chatId,
  limit = 50,
  cursor = null,
} = {}) {

  if (!chatId) {
    throw new Error(
      "chatId is required"
    );
  }

  try {

    const res =
      await axios.get(
        `/api/media-post/user/${encodeURIComponent(
          chatId
        )}`,
        {
          params: {
            limit,

            ...(cursor
              ? {
                  cursor,
                }
              : {}),
          },

          withCredentials: true,
        }
      );

    return res.data;

  } catch (err) {

    throw err;

  }

}